import UpdateBtn from './UpdateBtn';

export default UpdateBtn;
